var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Air Cargo P2P Rate Calculator")])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "airtransaction"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Name"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.clientList,
      "name": "clientName",
      "id": "client",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.clientName),
      callback: function($$v) {
        _vm.clientName = $$v
      },
      expression: "clientName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.clientName')),
      expression: "errors.has('airtransaction.clientName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Client ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Origin City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.originList,
      "name": "origincity",
      "id": "origin",
      "placeholder": "Select Origin City",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.origincity),
      callback: function($$v) {
        _vm.origincity = $$v
      },
      expression: "origincity"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.origincity')),
      expression: "errors.has('airtransaction.origincity')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Origin City ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.destinationList,
      "name": "destinationcity",
      "id": "destination",
      "placeholder": "Select Destination City",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.destinationcity),
      callback: function($$v) {
        _vm.destinationcity = $$v
      },
      expression: "destinationcity"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.destinationcity')),
      expression: "errors.has('airtransaction.destinationcity')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Destination City ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Business Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-book' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.businessTypeList,
      "name": "businesstype",
      "id": "business",
      "placeholder": "Select Business Type",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "disabled": _vm.businesstypedisbaled,
      "hide-selected": true
    },
    model: {
      value: (_vm.businesstype),
      callback: function($$v) {
        _vm.businesstype = $$v
      },
      expression: "businesstype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.businesstype')),
      expression: "errors.has('airtransaction.businesstype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Business Type ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Airline"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.airlineList,
      "name": "airline",
      "id": "airlinetype",
      "placeholder": "Select Airline Type",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.airline),
      callback: function($$v) {
        _vm.airline = $$v
      },
      expression: "airline"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.airline')),
      expression: "errors.has('airtransaction.airline')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Airline Type ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Product Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-briefcase' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.productTypeList,
      "name": "producttype",
      "id": "product",
      "placeholder": "Select Product Type",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.producttype),
      callback: function($$v) {
        _vm.producttype = $$v
      },
      expression: "producttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.producttype')),
      expression: "errors.has('airtransaction.producttype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Product Type ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Flight Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-plane' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.flightTypeList,
      "name": "flighttype",
      "id": "flight",
      "placeholder": "Select Flight Type",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.flighttype),
      callback: function($$v) {
        _vm.flighttype = $$v
      },
      expression: "flighttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.flighttype')),
      expression: "errors.has('airtransaction.flighttype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Flight Type ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Estimated Weight"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physicalweight),
      expression: "physicalweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "physicalweight",
      "id": "physicalwt",
      "placeholder": "Enter Physical Weight"
    },
    domProps: {
      "value": (_vm.physicalweight)
    },
    on: {
      "keyup": function($event) {
        _vm.isCheck($event, 'physicalweight')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.physicalweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('airtransaction.physicalweight')),
      expression: "errors.has('airtransaction.physicalweight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Enter Physical Weight ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "id": "calculate",
      "name": "calculaterate",
      "title": "Calculate Rate"
    },
    on: {
      "click": function($event) {
        _vm.calculate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" Calculate")]), _vm._v("   \n                            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "id": "reset",
      "name": "reset",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.resetFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calculatedamountflag == true),
      expression: "calculatedamountflag == true\n            "
    }],
    staticClass: "col-md-8-text-center",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h5', [_vm._v("Calculated Wallet Amount")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-success"
  }, [_vm._v("Wallet balance")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-success"
  }, [_vm._v(_vm._s(parseFloat(_vm.walletdata.walletbalance).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-warning"
  }, [_vm._v("Estimated Cost")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-warning"
  }, [_vm._v("         " + _vm._s(parseFloat(_vm.walletdata.estimatedcost).toFixed(2)) + "  "), _c('span', [_vm._v("    "), _c('button', {
    staticClass: "exclaimation",
    on: {
      "click": _vm.viewBifurcation
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    staticStyle: {
      "color": "#4b8857",
      "font-size": "14px"
    }
  })])])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-danger"
  }, [_vm._v("Amount Needed")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-danger"
  }, [_vm._v(_vm._s(parseFloat(_vm.walletdata.amountneeded).toFixed(2)))])])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.viewbifurcationflag = false
      }
    },
    model: {
      value: (_vm.viewbifurcationflag),
      callback: function($$v) {
        _vm.viewbifurcationflag = $$v
      },
      expression: "viewbifurcationflag"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n            Rate Break Up\n            "), _c('button', {
    staticClass: "close",
    attrs: {
      "id": "close",
      "name": "close",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-8-text-center",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Base Freight")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.basefreight).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Terminal charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.originterminalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Terminal Charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.destinationterminalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Other Charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.othercharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Operator Charges origin ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.originoperatorcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Operator Charges destination ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.destinationoperatorcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Extra Charge ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.extracharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-warning"
  }, [_vm._v("Total Charge ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-warning"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.totalcharge).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-success"
  }, [_vm._v("Total charges + GST (18%) ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-success"
  }, [_vm._v(_vm._s(parseFloat(_vm.bifurcationdata.totalchargewithgst).toFixed(2)))])])])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d10bda","hasScoped":true}!./src/modules/cargobooking/views/booking/airwalletratecalculator/airwalletratecalculator.component.html
// module id = 1292
// module chunks = 3